import { _t } from "@cruisen/i18n"
import { UserID, UserLikedTripNotificationData } from "@cruisen/contract"
import styles from "./styles.module.scss"
import { CruiseCardsCarousel } from "../../../cards/CruiseCardsCarousel"
import UserAvatar from "../../../atoms/UserAvatar"

export const CruiseSearchResultLiked = ({
  data,
  currentUserId,
}: {
  data: UserLikedTripNotificationData
  currentUserId: UserID
}) => {
  const { userId, userFirstName, userLastNameInitial, userAvatar } = data

  const authorName =
    currentUserId === userId ? _t("common.you") : `${userFirstName} ${userLastNameInitial}.`

  const likedCruises = data?.cruises || []
  const isCarousel = likedCruises?.length > 1

  return (
    <>
      <div className={styles.header}>
        <UserAvatar
          nameInitals={`${userFirstName[0]}${userLastNameInitial}`}
          avatar={userAvatar}
          customSize={28}
          fontSize={"14px"}
        />
        <p>
          <span className={styles.authorName}>{authorName}</span>
          {isCarousel ? " liked some cruises." : " liked a cruise."}
        </p>
      </div>
      <CruiseCardsCarousel data={data} testID="cruise-liked-message" />
    </>
  )
}
